import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { normalizeAmount } from "../../utils/transformer.util";
import {
  Button,
  Select,
  SearchSelect,
  SelectMultiple,
  Input,
} from "../../components/base/index";

const MySwal = withReactContent(Swal);

export default class ParameterJP extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onRemoveMulti = this._onRemoveMulti.bind(this);
    this._onChangeMulti = this._onChangeMulti.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this._getPrmStaffKepsekOptions = this._getPrmStaffKepsekOptions.bind(this);
    this._onAddList = this._onAddList.bind(this);
    this._onDeleteList = this._onDeleteList.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
         listJP: [],
        },
        error: {},
      },
      param: {},
    };
  }

  componentDidMount() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    const paramTypes = ["levels"];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });

    if (isEdit && data) {
      this._setForm(data);
    }
    // this._getSchoolUnitsOptions();
    this._onSearchContent();
    this._getPrmStaffKepsekOptions();
  }

  async _getPrmStaffKepsekOptions(filters = {}) {
    const { getPrmStaffKepsekOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getPrmStaffKepsekOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }



  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { school_unit, organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      // filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }
  // componentDidUpdate(prevProps) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   // if (!isEqual(workingUnit, prevWorkingUnit)) {
  //   //   this.handleGetData();
  //   // }
  //   if (!isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }

  async _setForm(data) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { form } = this.state;
    // this._getSchoolUnitsOptions({ levels_id: data.levels_id });

    try {
      this.setState({
        form: {
          value: {
            id: data.id,
            levels_id: data.levels_id,
            total_jp: data.total_jp,
          },
          error: {},
        },
      });
    } catch (err) {
      // err action
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === "user_groups_id") {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          username: "",
        },
      }));
    }
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        if (name === "perwakilan_id") {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: "",
              },
            },
          }));
          this._getSchoolUnitsOptions({ perwakilan_id: value.value });
          // if(value.value == 'all'){
          // this._onSearchContent();
          // }
        }
        // this._onSearchContent();
      }
    );
  }

  async onSubmit() {
    const { history, handleSaveParameterJP } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { levels_id, total_jp } = value;
    let canSaveA = false;

    if(levels_id && total_jp){
canSaveA = true;
    }
    else {
      canSaveA = false;
    }
     if (canSaveA == false) {
      alert('Harap lengkapi data form. Bagian yang harus diisi ditandai dengan tanda bintang (*).');
    } else {
    await handleSaveParameterJP(value);
    history.push("/dashboard/kurikulum/parameter-jp");
    history.go(0);
    }

  }

  async onEdit() {
    const { history, handleEditParameterJP } = this.props;
    const { form } = this.state;
    const { value } = form;
     const { levels_id, position_code, min_rombel, total_jp } = value;
    let canSaveA = false;

    if(levels_id && total_jp){
canSaveA = true;
    }
    else {
      canSaveA = false;
    }
     if (canSaveA == false) {
      alert('Harap lengkapi data form. Bagian yang harus diisi ditandai dengan tanda bintang (*).');
    } else {
    await handleEditParameterJP(value);
    history.push("/dashboard/kurikulum/parameter-jp");
    history.go(0);
    }
  }

  _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { rombels, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(rombels));
    newList.forEach((item) => {
      item.is_active = isBlocked;
    });

    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          rombels: newList,
        },
      },
    }));
  }

  
  async _onSearchContent(params = {}) {
    const { filters, param } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;


    this.setState(async () => {
      try {
        const { handleListParameterJP, user } = this.props;
        const { school_unit, organizations_id } = user;
        const result = await handleListParameterJP({
          organizations_id,
          units_id: school_unit.id,
          filters,
        });
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listJP: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listJP: [],
            },
          },
        }));
      }
      // }
    });
  }

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;
        //   if (name === 'staff'){
        //     console.log(value)
        //     const selectedStaff = param.staff.find(
        //       (item) => item.value == value.value
        //     )
        //     var parts = selectedStaff.label.split(' - ');
        //     const code = selectedStaff.label.split(' - ')[0].trim();
        // const staff_name = parts.length > 1 ? parts[1].trim() : '';
        // form.value.name = staff_name;
        // form.value.code = code;
        //   }
        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }

          newList = prevState.form.value[fieldName] || [];
          newListError = prevState.form.error[fieldName] || [];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "classes_id") {
          const param = this.state.param.classes_prm;
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                // graduate: param.find(i => i.value == value).attributes.graduate,
              },
            },
          }));
        }
      }
    );
  }

  _onRemoveMulti(
    selectedList,
    removedItem,
    inputArray,
    fieldName,
    arrayPosition
  ) {
    this._onFormChange({
      target: {
        name: removedItem,
        value: selectedList,
        dataset: {
          inputArray,
          fieldName,
          arrayPosition,
        },
      },
    });
  }

  _onChangeMulti(value, name, inputArray, fieldName, arrayPosition) {
    this._onFormChange({
      target: {
        name,
        value,
        dataset: {
          inputArray,
          fieldName,
          arrayPosition,
        },
      },
    });
  }

  _onAddList(data) {
    const { form } = this.state;
    const { rombels } = form.value;

    rombels.push({
      min_rombel: "",
      max_rombel: "",
      min_headcount: "",
      details: [],
    });

    this.setState((prevState) => ({
      form: {
        value: {
          ...prevState.form.value,
          rombels,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  async onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/parameter-jp', {
      data: val,
      isEdit: true,
    });
    history.go(0);
  }

  async onClickDelete(id) {
    const { history } = this.props;
    console.log(id)
    const { handleDeleteParameterJP, organizations_id } = this.props;
    const res = await handleDeleteParameterJP(id)
    if (res) {
      this._onSearchContent();
      // history.go(0);

    }
    
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const { rombels } = prevState.form.value;
      const list = prevState.form.value.rombels;

      list.splice(idx, 1);
      return {
        ...prevState,
        rombels: list,
      };
    });
  }
  _renderButtons(data) {
    const { user } = this.props;
    console.log(data.id)
    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }

  onClickAdd() {
    const { history } = this.props;
    history.push("/dashboard/kurikulum/tambah-master-mapel", {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  render() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { form, filters, param } = this.state;
    const { listJP } = form.value;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const dataGet = data || "";

    console.log(data)
    return (
      <div className="manage-registration">
        <h1>Pengaturan Parameter JP</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
          <div className="absensi-rekap__custom-form-row">
            <Select
              type="text"
              name="levels_id"
              label="Pilih Jenjang *"
              disabled={dataGet.id?true:false}
              placeholder={"Pilihan"}
              data={param.levels}
              onChange={this._onFormChange}
              value={form.value.levels_id}
            />
          </div>
          <Input
              type="number"
              name="total_jp"
              label="Total JP *"
              onChange={this._onFormChange}
              value={form.value.total_jp}
            />
        </div>
   
            <div className="student-list__button2">
              {dataGet.id ? (
                <Button type="button" title="Update" onClick={this.onEdit} />
              ) : (
                <Button type="button" title="Simpan" onClick={this.onSubmit} />
              )}
            </div>
                <div className="manage-registration">
                      <div className="fund-request__content">
                        <table className="table">
                          <thead>
                            <tr style={{textAlign:"center"}}>
                              <th>No</th>
                              <th>Jenjang</th>
                              <th>Total JP</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {map(listJP, (list, idx) => (
                              <tr key={`budget_row_${idx}`}>
                                <td style={{ textAlign: 'center' }} key={`table_$${idx}`}>
                                  {idx + 1}
                                </td>
                                <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                                  {list.name}
                                </td>
                                <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                                  {list.total_jp}
                                </td>
                                {this._renderButtons(list)}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
      </div>
    );
  }
}
ParameterJP.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
ParameterJP.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
